import { connect } from 'react-redux';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectIsSubmitPersonalisationFormPending,
  submitPersonalisationForm,
} from 'src/redux/personalisation';
import { selectFavouriteProduct } from 'src/redux/selectors';
import { AppThunkDispatch } from 'src/redux/store';
import { NextConfig } from 'src/types';
import { AddToBasketButton } from '../components/AddToBasketButton';
import { actions } from '../modules/slice';

const nextConfig = getConfig() as NextConfig;

const mapStateToProps = (state: ReduxApplicationState) => ({
  product: selectFavouriteProduct(state),
  isLoading: selectIsSubmitPersonalisationFormPending(state),
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onBuyGiftCard: () => dispatch(actions.onBuyGiftCard()),
  updateFavourite: (productCode: number) => dispatch(updateFavourite({ productCode, nextConfig })),
  submitPersonalisationForm: () => dispatch(submitPersonalisationForm()),
});

export const AddToBasketButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddToBasketButton);
